import {fs, csv} from "./electron-modules";
import path from 'path';
import { buildFilePath, detectImagePath } from "./asset-utils";
import { CameraData } from "./redux/assetsSlice";

const parseFinalData = async (assetPath, cameraData, cameraNames, resolve) => {
  const numCameras = cameraData.length;
  if (numCameras === 0) {
    resolve([]);
    return;
  }

  let {pathFound, imagePath, imageExt, hasImageExt}
    = await detectImagePath(assetPath, cameraNames[0]);

  if (!pathFound) {
    resolve([]);
    return;
  }

  // Update final camera data path / filenames
  for (let i=0;i<numCameras;i++) {
    let filename = cameraNames[i];
    let filePath = buildFilePath(imagePath, filename,
      imageExt, hasImageExt);

    cameraData[i] = {
      ...cameraData[i],
      path: filePath,
      name: path.basename(filePath)
    };
  }

  resolve(cameraData);
};

export const parseCSV = (csvPath: string, assetPath: string): Promise<CameraData[]> => {
  return new Promise((resolve, reject) => {
    const stream = fs.createReadStream(csvPath);
    const csvFilename = path.basename(csvPath);

    let cameraNames = [];
    let cameraData: CameraData[] = [];

    csv.parseStream(stream, {headers: true})
      .on('error', error => {
        reject(error);
      })
      .on('end', () => {
        parseFinalData(assetPath, cameraData, cameraNames, resolve);
      })
      .on('data', (row) => {
        const filename = row.filename || row.Filename;

        try {
          const data = {
            path: null,
            name: null,
            x: parseFloat(row.x || row.X),
            y: parseFloat(row.y || row.Y),
            z: parseFloat(row.z || row.Z),
            roll: parseFloat(row.roll || row.Roll),
            pitch: parseFloat(row.pitch || row.Pitch),
            yaw: parseFloat(row.yaw || row.Yaw)
          };

          cameraData.push(data);
          cameraNames.push(filename);
        } catch (err) {
          console.log(`${csvFilename}: error reading csv line`);
        }
      });
  });
};